
import {
  formatByCountry, ellipsisString,
  formatDate
} from "@/app/infrastructures/misc/Utils";
import { MainAppController } from "@/app/ui/controllers/MainAppController";
import { StoSCController } from "@/app/ui/controllers/StoSCController";
import generateLabelPdfSTOSC from "../modules/index";
import { AccountController } from "@/app/ui/controllers/AccountController";
import { generateManifest2ColumnPotrait } from "@/app/ui/modules/manifest-v2/potrait";
import { ColumnManifestData, SectionManifestData, HeaderManifestData } from "@/domain/entities/MainApp";
import { StoSCDetailStt } from "@/domain/entities/StoSC";
import { createI18n } from 'vue-i18n';
import en from "@/i18n/locales/en";
import id from "@/i18n/locales/id";
import my from "@/i18n/locales/my";

const dataProfile = () => {
  return AccountController.accountData;
}
const roleAccount = () => {
  return (
    (dataProfile().account_type === "partner"
      ? dataProfile().account_type_detail.type
      : dataProfile().account_type) || "internal"
  );
}

export const printSummary = async (id: number) => {
  const logo = await import(`@/app/ui/assets/images/logo-${roleAccount()}.png`);
  const printManifest = await StoSCController.getDetailSTOSC({ id, isPrint: true });
  if (printManifest) {
    const dataHead = StoSCController.detailSTOSC;

    const i18nInstance = createI18n({
      legacy: false,
      locale: AccountController.accountData.account_type_detail?.countryCode?.toLowerCase() || 'id',
      fallbackLocale: "id",
      globalInjection: false,
      messages: { en, id, my }
    });
    const t = i18nInstance.global.t;
    const countryCode = AccountController.accountData.account_type_detail?.countryCode;

    const fields = [
      {
        name: String(t("stoSc.pdf.totalStt")),
        value: dataHead.totalSTT,
      },
      {
        name: String(t("stoSc.pdf.totalKoli")),
        value: dataHead.totalPiece,
      },
      {
        name: String(t("stoSc.pdf.totalWeight")),
        value: `${formatByCountry(dataHead.totalGrossWeight, { type: 'weight', country: countryCode, fractionDigits: 2 })} ${t("stoSc.common.unitKg")}`,
      },
      {
        name: String(t("stoSc.pdf.totalVolumeWeight")),
        value: `${formatByCountry(dataHead.totalVolumeWeight, { type: 'weight', country: countryCode, fractionDigits: 2 })} ${t("stoSc.common.unitKg")}`,
      },
      {
        name: String(t("stoSc.pdf.stoScDate")),
        value: formatDate(dataHead.stoScDate)?.replace(/,/g, " -"),
      },
      {
        name: String(t("stoSc.pdf.updatedBy")),
        value: ellipsisString(dataHead.updatedBy, 21),
      },
    ];
    generateLabelPdfSTOSC(
      `${ellipsisString(dataProfile().name, 21)} '${t("stoSc.pdf.summaryTitle", { id: dataHead.stoScId })}'`,
      fields,
      logo.default
    );
  }
  MainAppController.closeLoading();
}

export const printManifestStoSC = async (id: number) => {
  const isSuccessPrint = await StoSCController.getDetailSTOSC({ id, isPrint: true });
  if (isSuccessPrint) {
    const dataManifest = StoSCController.detailSTOSC;

    const i18nInstance = createI18n({
      legacy: false,
      locale: AccountController.accountData.account_type_detail?.countryCode?.toLowerCase() || 'id',
      fallbackLocale: "id",
      globalInjection: false,
      messages: { en, id, my }
    });
    const t = i18nInstance.global.t;

    const data = new SectionManifestData({
      featureName: String(t("stoSc.manifest.featureName", { id: dataManifest.stoScId })),
      headerDetailData: new HeaderManifestData({
        totalStt: dataManifest.totalSTT,
        totalPiece: dataManifest.totalPiece,
        totalGrossWeight: dataManifest.totalGrossWeight,
        totalVolumeWeight: dataManifest.totalVolumeWeight,
        updatedAt: dataManifest.updatedAt,
        updatedBy: dataManifest.updatedBy
      }),
      headerSection: [
        'accountTypeName',
        'totalStt',
        'totalPiece',
        'totalGrossWeight',
        'totalVolumeWeight',
        'updatedAt',
        'updatedBy'
      ],
      data: dataManifest.stt.map(
        (item: StoSCDetailStt) =>
          new ColumnManifestData({
            sttNo: item.sttNo,
            totalGrossWeight: item.sttGrossWeight,
            totalPiece: item.sttTotalPiece
          })
      ),
      totalColumnHeader: 3,
      signature: true
    });
    generateManifest2ColumnPotrait(data);
  }
  MainAppController.closeLoading();
}

